// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1v6i4","left":"InfoRow_left__2Ic2R"};